import _ from 'lodash';

const invoicesStatusWithPdf = ["Ok", "Dunning1", "Dunning2"];
export const isPdfAvailable = invoice => true;//_.includes(invoicesStatusWithPdf, invoice.status) SD: enabling invoices for all statuses as noone really knows which statuses are being exported to invoice hotel and can be downloaded as pdf and list above was not enough
export const getInvoices = state => state.customer.profile.invoices.invoiceList;
export const isLoading = state => state.customer.profile.invoices.isLoading;
export const getNumberOfInvoices = noOfInvoices => state => _.take(getInvoices(state), noOfInvoices);

export const getFinancialBalance = state => state.customer.profile.invoices.balance;